import React from "react";
import { HashRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import { base_path } from "./environment.jsx";
import '../src/style/css/feather.css';
import '../src/style/css/line-awesome.min.css';
import "../src/style/scss/main.scss";
import '../src/style/icons/fontawesome/css/fontawesome.min.css';
import '../src/style/icons/fontawesome/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { Provider } from "react-redux";
import { UserProvider } from '../src/context/userContext.js'
import { LoadingProvider } from '../src/context/loadingContext.js'
import store from "./core/redux/store.jsx";
import AllRoutes from "./Router/router.jsx";
import axios from "axios";
import { QueryClientProvider, QueryClient } from 'react-query';

// Set up axios defaults
//axios.defaults.baseURL = 'http://localhost:8002/api'; // Replace with your actual base URL
 axios.defaults.baseURL = 'https://api-oki.eyerax.tech/api'; // Replace with your actual base URL
// axios.defaults.headers.common['Content-Type'] = 'application/json';

// Create a QueryClient instance
const queryClient = new QueryClient();

// Add interceptor to include user info in request headers
axios.interceptors.request.use(
    async (config) => {
        // Attach session token or user info to headers
        if (localStorage.getItem('user') != null) {
            config.headers['x-user-id'] = JSON.parse(localStorage.getItem('user')).data._id; // Use a custom header for user session
        }
        return config;
    },

    (error) => {
        console.log("Error", error);
        return Promise.reject(error);
    }
);
const rootElement = document.getElementById('root');

if (rootElement) {
    // Create a root using createRoot from react-dom/client
    const root = createRoot(rootElement);

    // Render the app
    root.render(
        <QueryClientProvider client={queryClient}>
            <UserProvider><LoadingProvider>
                <Provider store={store}>
                    <HashRouter basename={base_path}>
                        <AllRoutes />
                    </HashRouter>
                </Provider></LoadingProvider>
            </UserProvider>

        </QueryClientProvider>
    );
} else {
    console.error("Element with id 'root' not found.");
}